export default "__VITE_ASSET__5wsPto1I__"